export const envName = `${process.env.APP_CODE || 'my-tbapptech-net'}-${process.env.NODE_ENV || "development"}`;
